<div class="pwd-checklist">
  <div class="pwd-checklist-title">Your password must have:</div>
  <ul>
    <li [class.met]="rules.length">
      <i [ngClass]="rules.length ? 'fa-check-circle' : 'fa-circle-thin'" aria-hidden="true" class="fa"></i> At least 8 characters
    </li>
    <li [class.met]="rules.lowercase">
      <i [ngClass]="rules.lowercase ? 'fa-check-circle' : 'fa-circle-thin'" aria-hidden="true" class="fa"></i> A lowercase letter
    </li>
    <li [class.met]="rules.uppercase">
      <i [ngClass]="rules.uppercase ? 'fa-check-circle' : 'fa-circle-thin'" aria-hidden="true" class="fa"></i> An uppercase letter
    </li>
    <li [class.met]="rules.digit">
      <i [ngClass]="rules.digit ? 'fa-check-circle' : 'fa-circle-thin'" aria-hidden="true" class="fa"></i> A number
    </li>
    <li [class.met]="rules.special">
      <i [ngClass]="rules.special ? 'fa-check-circle' : 'fa-circle-thin'" aria-hidden="true" class="fa"></i> A special character
    </li>
    <li [class.met]="rules.match">
      <i [ngClass]="rules.match ? 'fa-check-circle' : 'fa-circle-thin'" aria-hidden="true" class="fa"></i> Passwords match
    </li>
  </ul>
</div>
